import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import LocationCityBase from './views/LocationCityBase.vue'
import Cart from './views/Cart.vue'
import Pizza from './views/Pizza.vue'
import Product from './views/Product.vue'
import AboutUs from './views/AboutUs.vue'
import Offer from './views/Offer.vue'
import Application from './views/Application.vue'
import Cooperation from './views/Cooperation.vue'
import DeliveryMap from "@/views/DeliveryMap.vue";

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/:locationCity(kyiv|lutsk+)',
      component: LocationCityBase,
      children: [
        {
          path: '',
          name: 'pizza',
          component: Pizza
        },
        {
          path: 'category/:code',
          name: 'category.index',
          component: Product,
        },
        {
          path: 'cart',
          name: 'cart',
          component: Cart
        },
        {
          path: 'about-us',
          name: 'about-us',
          component: AboutUs
        },
        {
          path: 'delivery-map',
          name: 'delivery-map',
          component: DeliveryMap
        },
        {
          path: 'offer',
          name: 'offer',
          component: Offer
        },
        {
          path: 'application',
          name: 'application',
          component: Application
        },
        {
          path: 'cooperation',
          name: 'cooperation',
          component: Cooperation
        }
      ],
    },
  ]
})
